(function() {
  if (window.innerWidth > 749) return;

  const TARGET_HEIGHT = 280; // change to whatever height you want

  function shrink() {
    const slides = document.querySelectorAll('.m-product-media-slider .swiper-slide');
    if (!slides.length) return;

    let firstImageSlide = null;
    let firstImg = null;

    for (const slide of slides) {
      const img = slide.querySelector('img');
      if (!firstImageSlide && img) {
        firstImageSlide = slide;
        firstImg = img;
        break;
      }
    }

    if (!firstImageSlide || !firstImg) return;

    firstImageSlide.style.height = TARGET_HEIGHT + 'px';
    firstImageSlide.style.maxHeight = TARGET_HEIGHT + 'px';
    firstImageSlide.style.overflow = 'hidden';

    const responsive = firstImageSlide.querySelector('responsive-image');
    if (responsive) {
      responsive.style.setProperty('--aspect-ratio', '1');
      responsive.style.paddingBottom = '0';
      responsive.style.height = TARGET_HEIGHT + 'px';
      responsive.style.maxHeight = TARGET_HEIGHT + 'px';
    }

    firstImg.style.height = TARGET_HEIGHT + 'px';
    firstImg.style.width = '100%';
    firstImg.style.objectFit = 'cover';
    firstImg.style.objectPosition = 'center';
  }

  // reapply after DOM mutations (Minimog re-renders slides)
  const obs = new MutationObserver(shrink);
  obs.observe(document.body, { childList: true, subtree: true });

  // apply on intervals (cover transitions)
  let tries = 0;
  const iv = setInterval(() => {
    shrink();
    tries++;
    if (tries > 20) clearInterval(iv);
  }, 300);

})();
